<div class="container">
  <div class="text-center justify-content-center">
    <h1 class="fs-3 fw-bold" style="color: #8e0e00">Approve Order</h1>
  </div>
  <div class="row">
    <!-- Export and Print Buttons Section -->
    <div class="col-md-9 col-sm-6 d-flex justify-content-start">
      <button class="btn btn-outline-secondary" type="button" ngbTooltip="Export">
        Export
      </button>
      <!-- <button class="btn btn-outline-secondary ms-2" type="button" ngbTooltip="Print">
                Print
            </button> -->
      <button class="btn btn-outline-secondary ms-2" type="button" (click)="clearFilter()" ngbTooltip="Clear Filter">
        Clear Filter
      </button>
    </div>
    <!-- Search Box Section -->
    <div class="col-md-3 col-sm-6 d-flex justify-content-start">
      <input type="text" class="form-control" placeholder="Search..." (input)="onSearch($event)" />
    </div>
  </div>

  <!--------------------------------- Table --------------------------------->

  <div class="card p-3 shadow-lg mt-3">
    <div class="justify-content-start">
      <h5 class="fs-5 fw-bold">Order Details</h5>
    </div>
    <div class="table-responsive">
      <table class="table table-bordered table-striped table-hover" style="max-width: 100%; overflow-x: auto">
        <thead>
          <tr>
            <!-- <th *ngFor="let header of tableHeader" class="text-center position-relative">{{ header }}
                            <i *ngIf="['requestorType', 'City', 'Zone', 'Category', 'Payment Status', 'Order Status'].includes(header)"
                                class="bi bi-funnel ms-2" (click)="toggleDropdown(header)"></i>
                            
                            <div *ngIf="activeDropdown === header" class="dropdown-menu show"
                                style="position: absolute; top: 100%; left: 50%; transform: translateX(-50%); z-index: 1050;">
                                <div class="px-3 py-2">
                                    <div class="filter-options" style="max-height: 200px; overflow-y: auto;">
                                        <div *ngFor="let option of availableFilters[header]" class="dropdown-item"
                                            (click)="applyFilter($event, header)">
                                            {{ option }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </th> -->

            <th>Order ID</th>
            <th>Requestor Type</th>
            <th>Requestor Name</th>
            <th>Requestor mobile no</th>
            <th>Request Date</th>
            <th>Scheduled Date</th>
            <th>
              City
              <i class="bi bi-funnel" id="dumpedStatusDropdown" data-bs-toggle="dropdown"></i>

              <ul class="dropdown-menu" aria-labelledby="dumpedStatusDropdown">
                <li>
                  <a class="dropdown-item" (click)="filterData('All', '')">All</a>
                </li>
                <li *ngFor="let city of uniqueCities" (click)="filterData('', city)">
                  <a class="dropdown-item">{{ city }}</a>
                </li>
              </ul>
            </th>
            <th>Order Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedData; let i = index">
            <td (click)="openDetailModal(detailsModal, row)"
              class="custom-width pointer text-center custom-column-width">
              <a class="hyperLink" style="color: #8e0e00">{{ row.orderId }}</a>
            </td>
            <td class="custom-width text-center">{{ row.requestorType }}</td>
            <td class="text-center">{{ row.requestorType == 'Individual Requester' ? row.requestorName : row.companyName }}</td>
            <td class="text-center">{{ row.requestorMobile }}</td>
            <td class="text-center custom-width">
              {{ row.requestDate | date : "dd MMM yyyy" }}
            </td>
            <td class="text-center custom-width">
              {{ row.scheduledDate | date : "dd MMM yyyy" }}
            </td>
            <td class="text-center">{{ row.city }}</td>
            <td class="text-center" style="width: 13%; text-align: center">
              {{ row.currentOrderStatus }}
            </td>
            <td class="text-center" style="width: 20%; cursor: pointer">
              <span (click)="openConfirmationModal(row)">
                <a class="hyperLink" style="color: #8e0e00" *ngIf="row.currentOrderStatusID < '102'">Confirm Payment</a>
                <!-- Show status dot and text when payment is received -->
                <span *ngIf="row.currentOrderStatusID >= '102'" class="d-flex align-items-center">
                  <span class="status-dot text-center" style="background-color: green"></span>
                  Sar Received
                </span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center align-items-center text-center" *ngIf="pagedData?.length === 0">
        <h3>No Data Found</h3>
      </div>
      <!-- Pagination -->
    </div>
    <div class="d-flex justify-content-center" *ngIf="approveOrderList?.length > 5">
      <ngb-pagination [(page)]="currentPage" [pageSize]="pageSize" [collectionSize]="approveOrderList?.length"
        (pageChange)="onPageChange($event)" [maxSize]="3" [boundaryLinks]="true">
      </ngb-pagination>
    </div>
    <div *ngIf="approveOrderList?.length > 0" class="text-muted text-end mb-3">
      <strong>Showing {{ (currentPage - 1) * pageSize + 1 }} to {{ (currentPage * pageSize) > approveOrderList?.length ?
        approveOrderList?.length
        :currentPage *pageSize }} of {{ approveOrderList?.length }} entries</strong>
    </div>
  </div>
</div>

<!--------------------------------- Confirm popup --------------------------------->

<ng-template #confirmationModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-2">Confirm Payment ({{ selectedOrderId }})</h3>
    <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    Are you sure the payment has been received from the requestor (
    {{ requestorName }})?
  </div>
  <div class="modal-footer">
    <button type="button" class="btn custom-confirm-btn" (click)="postOrderStatus(modal)">
      Confirm
    </button>
    <button type="button" class="btn custom-cancel-btn" (click)="modal.dismiss('Cancel click')">
      Cancel
    </button>
  </div>
</ng-template>

<!--------------------------------- Details popup --------------------------------->

<ng-template #detailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Order Details - ({{ selectedOrderId }})</h3>
    <button type="button" class="btn-close" style="background-color: white !important" aria-label="Close"
      (click)="modal.dismiss('Cross click')"></button>
  </div>
  <form [formGroup]="orderForm">
    <div class="modal-body custom-modal">
      <!-- User Type Form Group -->
      <div class="mb-3 row">
        <label for="userType" class="col-sm-4 col-form-label text-start">Requestor Type</label>
        <div class="col-sm-8">
          <input id="userType" formControlName="userType" class="form-control" [readonly]="true" />
        </div>
      </div>

      <!-- Company Name Form Group -->
      <div class="mb-3 row">
        <label for="companyName" class="col-sm-4 col-form-label text-start">
          Name</label>
        <div class="col-sm-8">
          <input id="companyName" formControlName="companyName" class="form-control" [readonly]="true" />
        </div>
      </div>

      <!-- Mobile Number Form Group -->
      <div class="mb-3 row">
        <label for="mobileNumber" class="col-sm-4 col-form-label text-start">
          Mobile Number</label>
        <div class="col-sm-8">
          <input id="mobileNumber" formControlName="mobileNumber" class="form-control" [readonly]="true" type="text" />
        </div>
      </div>

      <!-- Address Form Group -->
      <div class="mb-3 row">
        <label for="location" class="col-sm-4 col-form-label text-start">
          Location</label>
        <div class="col-sm-8">
          <textarea id="location" formControlName="location" class="form-control" [readonly]="true" rows="3"></textarea>
        </div>
      </div>

      <!-- Email Form Group -->
      <div class="mb-3 row">
        <label for="city" class="col-sm-4 col-form-label text-start">City</label>
        <div class="col-sm-8">
          <input id="city" formControlName="city" class="form-control" [readonly]="true" type="email" />
        </div>
      </div>

      <!-- City Form Group -->
      <div class="mb-3 row">
        <label for="zone" class="col-sm-4 col-form-label text-start">Zone</label>
        <div class="col-sm-8">
          <input id="zone" formControlName="zone" [readonly]="true" class="form-control" />
        </div>
      </div>

      <!-- Zone Form Group -->
      <div class="mb-3 row">
        <label for="reqDate" class="col-sm-4 col-form-label text-start">Request Date & Time</label>
        <div class="col-sm-8">
          <input id="reqDate" formControlName="reqDate" [readonly]="true" class="form-control" />
        </div>
      </div>

      <!-- Bank Name Form Group -->
      <div class="mb-3 row">
        <label for="scheduledDate" class="col-sm-4 col-form-label text-start">Scheduled Date & Time</label>
        <div class="col-sm-8">
          <input id="scheduledDate" formControlName="scheduledDate" class="form-control" [readonly]="true" />
        </div>
      </div>

      <!-- Container Name No Form Group -->
      <div class="mb-3 row">
        <label for="containerName" class="col-sm-4 col-form-label text-start">Container Type</label>
        <div class="col-sm-8">
          <input id="containerName" formControlName="containerName" [readonly]="true" class="form-control" />
        </div>
      </div>

      <!-- Bank Account No Form Group -->
      <div class="mb-3 row">
        <label for="containerCapacity" class="col-sm-4 col-form-label text-start">Container Capacity</label>
        <div class="col-sm-8">
          <input id="containerCapacity" formControlName="containerCapacity" [readonly]="true" class="form-control" />
        </div>
      </div>

      <!-- CR Number Form Group -->
      <div class="mb-3 row">
        <label for="containerCount" class="col-sm-4 col-form-label text-start">No Of Containers</label>
        <div class="col-sm-8">
          <input id="containerCount" formControlName="containerCount" [readonly]="true" class="form-control" />
        </div>
      </div>

      <!-- CR Document Form Group -->
      <div class="mb-3 row">
        <label for="rentalDuration" class="col-sm-4 col-form-label text-start">Rental Duration (Weeks)</label>
        <div class="col-sm-8">
          <input id="rentalDuration" formControlName="rentalDuration" [readonly]="true" class="form-control">
        </div>
      </div>

      <div class="mb-3 row">
        <label for="sar" class="col-sm-4 col-form-label text-start">SAR</label>
        <div class="col-sm-8">
          <input id="sar" formControlName="sar" [readonly]="true" class="form-control" />
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ngx-spinner bdColor="rgba(0,0,0,0.1)" color="#8E0E00" size="default" type="ball-clip-rotate"></ngx-spinner>